import {ConfirmationDialog} from '@primer/react'
import type {ReactNode} from 'react'

export interface FailureDialogProps {
  title: ReactNode
  message: ReactNode
  details: ReactNode
  onRetry: () => void
  onDismiss: () => void
}

export function FailureDialog({title, message, details, onRetry, onDismiss}: FailureDialogProps) {
  return (
    <ConfirmationDialog
      title={title}
      onClose={gesture => (gesture === 'confirm' ? onRetry() : onDismiss())}
      confirmButtonContent="Retry"
      cancelButtonContent="Dismiss"
    >
      {message}
      <details className="mt-2">
        <summary>Details</summary>
        <p>{details}</p>
      </details>
    </ConfirmationDialog>
  )
}
